import React, { useEffect } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, UncontrolledTooltip, Card
} from 'reactstrap'
import _ from 'lodash'
import ReactTable from 'react-table'

import PageTitle from 'components/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import DeleteConfirmation from 'components/Modal/delete'
import Lang from 'Lang/General'

import TagForm from './Form'
import WithTagsHOC from './actions.js'

const Tags = props => {
  useEffect( () => {
    props.getTags()
  }, [] )

  useEffect( () => {
    if( !props.showCreateTag ){
      props.onChangeTagsHOC( 'newTag', { name: { en: '', de: '', it: '', nl: '' } } )
    }
  }, [ props.showCreateTag ] )

  useEffect( () => {
    if( !props.showUpdateTag ){
      props.onChangeTagsHOC( 'selectedTag', {} )
    }
  }, [ props.showUpdateTag ] )

  const handleSecurityModulesCreate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_create
    }
  }

  const handleSecurityModulesUpdate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_update
    }
  }

  const handleSecurityModulesDelete= () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_delete
    }
  }

  const renderCreateTagModal = () => (
    <Modal size='md' isOpen={ props.showCreateTag } >
      <ModalHeader toggle={ () => props.onChangeTagsHOC( 'showCreateTag', false ) } >
        { Lang[ 'CREATE' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <TagForm
          tagType='newTag'
          currentTag={ props.newTag }
          onChangeTagsHOC={ props.onChangeTagsHOC }
          lang={ props.data.languageReducer.lang }
        />
        { props.onLoadTagsHOC && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => props.createTag( props.newTag ) }>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )

  const renderUpdateTagModal = () => (
    <Modal size='md' isOpen={ props.showUpdateTag } >
      <ModalHeader toggle={ () => props.onChangeTagsHOC( 'showUpdateTag', false ) } >
        { Lang[ 'UPDATE' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <TagForm
          tagType='selectedTag'
          currentTag={ props.selectedTag }
          onChangeTagsHOC={ props.onChangeTagsHOC }
          lang={ props.data.languageReducer.lang }
        />
        { props.onLoadTagsHOC && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => props.updateTag( props.selectedTag ) }>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )

  return(
    <>
      <PageTitle
        heading={ Lang[ 'CONTENT_TAGS' ][ props.data.languageReducer.lang ] }
        icon="pe-7s-users icon-gradient bg-happy-fisher"
        buttons={[
          {
            buttonText: Lang[ 'CREATE' ][ props.data.languageReducer.lang ],
            onClick: () => props.onChangeTagsHOC( 'showCreateTag', true ),
            display: handleSecurityModulesCreate()
          }
        ]}/>
      <Card className='p-4'>
        <ReactTable
          showPagination
          pageSize={ 10 }
          data={ props.tags }
          columns={[
            {
              Header: Lang[ 'NAME' ][ props.data.languageReducer.lang ],
              accessor: "name",
              Cell: ({ value }) => value[ props.data.languageReducer.lang ] 
            },
            {
              Header: Lang[ 'ACTIONS' ][ props.data.languageReducer.lang ],
              accessor: "id",
              Cell: ({ value }) => (
                <div className='d-flex w-100 justify-content-center' >
                  {
                    handleSecurityModulesUpdate() && (
                      <>
                        <Button
                          id={ `Tag-${ value }-update` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="primary"
                          onClick={ () => props.getSelectedTag( value ) }>
                          <i className="pe-7s-note"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `Tag-${ value }-update` }
                          placement="top">{ Lang[ 'EDIT' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                  {
                    handleSecurityModulesDelete() && (
                      <>
                        <Button
                          id={ `Tag-${ value }-archive-tag` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="danger"
                          onClick={ () => props.onChangeTagsHOC( 'showDeleteTagId', parseInt( value ) ) }>
                          <i className="pe-7s-trash"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `Tag-${ value }-archive-tag` }
                          placement="top">{ Lang[ 'REMOVE' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                </div>
              )
            }
          ]}
        />
      </Card>
      <DeleteConfirmation
        handleModalClose={ () => props.onChangeTagsHOC( 'showDeleteTagId', 0 ) }
        deleteOpen={ props.showDeleteTagId > 0 }
        confirmAction={ () => props.removeTag( props.showDeleteTagId ) }
        content={ Lang[ 'DELETE_CONFIRMATION_TAG' ][ props.data.languageReducer.lang ] }
        lang={ props.data.languageReducer.lang } />
      { renderCreateTagModal() }
      { renderUpdateTagModal() }
      { props.onLoadTagsHOC && <LoadingOverlay/> }
    </>
  )
}

export default WithTagsHOC( Tags )